import { GetOneExpeditionResponseDto, UpdatePendingQuotationDto } from "@/types/api/api-types";
import { CotationFormData } from "@/types/forms/home/cotationFormData.form";
import { arraysEqual } from "@/lib/utils";

export const updatePendingQuotationPayload = (
  expedition: GetOneExpeditionResponseDto,
  data: CotationFormData,
) => {
  if (!expedition.quotation) {
    throw new Error("Quotation not found");
  }

  const deliveryFromDate =
    data.deliveryDateRadio === "earliestDelivery"
      ? null
      : data.deliveryDateRadio === "customDelivery"
        ? data.customDeliveryDate
          ? data.customDeliveryDate.toISOString()
          : null
        : null;

  const products = data.products.map((product) => ({
    volume: Number(product.volume),
    bottleQuantity: product.bottleQuantity,
    value: product.value,
  }));

  const woodBoxes = data.woodBoxes.map((woodBox) => ({
    bottleQuantity: woodBox.bottleQuantity,
    boxQuantity: woodBox.boxQuantity,
    bottleVolume: Number(woodBox.bottleVolume),
  }));

  const productsEqual = arraysEqual(expedition.quotation.quotationProducts || [], products);

  const woodBoxesEqual = arraysEqual(
    expedition.quotation.quotationWoodBox || [],
    data.woodBoxesActivated ? woodBoxes : [],
  );

  const updatePendingQuotationPayload: UpdatePendingQuotationDto = {
    ...(data.country !== expedition.quotation.customId && {
      customId: data.country,
    }),
    ...(data.dapOption !== expedition.expeditionOptions.dapOption && {
      dapOption: data.dapOption,
    }),
    ...(data.express !== expedition.expeditionOptions.express && {
      express: data.express,
    }),
    ...(data.insurance !== expedition.expeditionOptions.insurance && {
      insurance: data.insurance,
    }),
    ...(data.customer.firstName !== expedition.deliveryInfo?.firstName && {
      firstName: data.customer.firstName,
    }),
    ...(data.customer.lastName !== expedition.deliveryInfo?.lastName && {
      lastName: data.customer.lastName,
    }),
    ...(data.customer.companyName !== expedition.deliveryInfo?.company && {
      company: data.customer.companyName,
    }),
    ...(deliveryFromDate !== expedition.deliveryInfo?.deliveryFromDate && {
      deliveryFromDate: deliveryFromDate,
    }),
    ...(!productsEqual && {
      cotationProducts: products,
    }),
    ...(!woodBoxesEqual && {
      cotationWoodBox: data.woodBoxesActivated ? woodBoxes : [],
    }),
  };
  return updatePendingQuotationPayload;
};
